import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSearchPageBrandTilesRelatedToSearch } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageBrandTilesRelatedToSearch";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import getBrandTileReviews from "@faire/web-api--source/api/v2/products/search/brand-tile-reviews/post";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
var SEARCH_PAGE_BRAND_TILE_REVIEWS_QUERY_KEY = "SearchPageBrandTileReviews";
export var useSearchPageLoggedOutBrandTileReviewsQuery = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    // Do not fetch reviews if the user is logged in
    var brandTilesRelatedToSearch = useSearchPageBrandTilesRelatedToSearch(!isLoggedInRetailer).brandTilesRelatedToSearch;
    var query = useSearchPageProductSearchString();
    var isProductsResponseLoading = useSearchPageQueryIsLoading();
    var brandTokens = useMemo(function() {
        var _brandTilesRelatedToSearch_map_filter;
        return (_brandTilesRelatedToSearch_map_filter = brandTilesRelatedToSearch === null || brandTilesRelatedToSearch === void 0 ? void 0 : brandTilesRelatedToSearch.map(function(item) {
            var _item_brand;
            return (_item_brand = item.brand) === null || _item_brand === void 0 ? void 0 : _item_brand.token;
        }).filter(isNotUndefined)) !== null && _brandTilesRelatedToSearch_map_filter !== void 0 ? _brandTilesRelatedToSearch_map_filter : [];
    }, [
        brandTilesRelatedToSearch
    ]);
    return useQuery({
        queryKey: [
            SEARCH_PAGE_BRAND_TILE_REVIEWS_QUERY_KEY,
            brandTokens,
            query
        ],
        queryFn: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var signal;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            signal = param.signal;
                            return [
                                4,
                                getBrandTileReviews({
                                    brand_tokens: brandTokens,
                                    query: query
                                }, {
                                    signal: signal
                                })
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        enabled: !isLoggedInRetailer && brandTokens.length > 0 && !isProductsResponseLoading,
        staleTime: Infinity,
        placeholderData: keepPreviousData
    });
};
